// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"vn","wrapper":"vo","iconButton":"vp","icon":"vq","activeIcon":"vr"};